module.exports = __webpack_public_path__ + "img/電気回路_3_7_3.f5ebea5d.png";